import { Component } from '@angular/core';
import { ObjackLogoComponent } from '../../components/icons/objack-logo/objack-logo.component';
import { MessageDesignBGlobalComponent } from '../../components/message-design-b/message-design-b-global/message-design-b-global.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cp-auth-page-common',
    templateUrl: './auth-page-common.component.html',
    styleUrl: './auth-page-common.component.scss',
    imports: [ObjackLogoComponent, MessageDesignBGlobalComponent, TranslateModule]
})
export class AuthPageCommonComponent {
}
